import {createSelector} from 'reselect';

import {NONE_CURRENCY_VALUE} from '@stubhub/currency-utils';
import {getSelectedCurrencyCode} from '@stubhub/react-currency-exchange';
import getStoreCurrencyCode from '@stubhub/react-store-default-currency';

import {URL_CURRENCY_PARAM_KEY} from './config/constants';
import COUNTRY_CURRENCY_MAPPING from './config/countriesWhitelist';
import FEATURE_FLAGS from './config/featureFlags';

const currencyExchangeSelector = (store) => store?.currencyExchange || {};
const gsConfigSelector = (store) => store?.gsConfig || {};
const featureFlagsSelector = createSelector(gsConfigSelector, ({features}) => features || {});
const shstoreIdSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig?.shstoreId);
const defaultLocaleSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig?.defaultLocale);
const currentLocaleSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig?.currentLocale);
const supportedLocalesSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig?.supportedLocales || []);

const advisoryEnabledSelector = createSelector(
  featureFlagsSelector,
  (features) => !!features[FEATURE_FLAGS.advisory.enabled]
);

const advisoryOptOutEnabledSelector = createSelector(
  featureFlagsSelector,
  (features) => !!features[FEATURE_FLAGS.advisory.optOut]
);

const defaultCurrencyCodesSelector = createSelector(
  currencyExchangeSelector,
  (currencyExchange) => currencyExchange?.defaultCurrencyCodes || []
);

const userIpCountrySelector = createSelector(
  (state) => state?.user || {},
  (user) => user.ipLocation?.countryCode
);

const supportedCurrenciesSelector = createSelector(
  currencyExchangeSelector,
  (currencyExchange) => currencyExchange?.supportedCurrencies || []
);

const selectedCurrencySelector = createSelector(
  ({currencyExchange = {}}) => currencyExchange.selectedCurrency,
  supportedCurrenciesSelector,
  advisoryOptOutEnabledSelector,
  shstoreIdSelector,
  userIpCountrySelector,
  (_, search) => search,
  (selectedCurrency, supportedCurrencies, isOptOut, storeId, userIpCountry, search) => {
    const searchParams = new URLSearchParams(search);
    const storedCurrency = getSelectedCurrencyCode();
    const validatedStoredCurrency =
      storedCurrency === NONE_CURRENCY_VALUE || supportedCurrencies.some(({key}) => key === storedCurrency)
        ? storedCurrency
        : null;
    const urlCurrency = searchParams.get(URL_CURRENCY_PARAM_KEY);

    if (
      urlCurrency &&
      !validatedStoredCurrency &&
      !selectedCurrency &&
      supportedCurrencies.some(({key}) => key === urlCurrency)
    ) {
      return urlCurrency;
    }
    if (isOptOut && !validatedStoredCurrency && !selectedCurrency) {
      return COUNTRY_CURRENCY_MAPPING[userIpCountry] || getStoreCurrencyCode(storeId);
    }

    return selectedCurrency ? selectedCurrency : validatedStoredCurrency;
  }
);

export {
  advisoryEnabledSelector,
  defaultCurrencyCodesSelector,
  selectedCurrencySelector,
  supportedCurrenciesSelector,
  userIpCountrySelector,
  defaultLocaleSelector,
  currentLocaleSelector,
  supportedLocalesSelector,
};
